<template>
<div>
  <div class="pt-60 fs-26 bold">{{info.moduleTitle}}</div>
  <div class="tab-mol carousel-mol">
    <el-carousel :height="h" indicator-position="none" :autoplay="false" :arrow="dataList.length > 1 ? 'hover' : 'never'" :loop="false" v-if="dataList.length">
      <el-carousel-item v-for="(item, i) in dataList" :key="i">
         <ul class="p-type-list" style="padding: 10px 60px">
          <li v-for="(o, j) in item" :key="j" @click="goDetail(o)">
            <div>
              <div class="bold t-overflow" v-if="showContent.includes('商品名称')">{{o.name}}</div>
              <div class="t-overflow mt-10 col-gray" v-if="showContent.includes('商品品牌') || showContent.includes('商品分类')">
                {{showContent.includes('商品分类') ? o.sortName : '--'}}
                {{showContent.includes('商品品牌') && showContent.includes('商品分类') ? '-' : ''}}
                {{showContent.includes('商品品牌') ? o.brandName : '--'}}
              </div>
              <div class="img-icon mt-20" v-if="showContent.includes('商品图片')">
                <img :src="o.img" v-if="o.img"/>
              </div>
              <div class="a-foot mt-20" v-if="showContent.includes('商品价格')">
                <span>RMB {{o.sellingPrice}}起</span>
                <el-button type="primary" class="btn-1" round>购买</el-button>
              </div>
            </div>
          </li>
        </ul>
      </el-carousel-item>
    </el-carousel>
  </div>
</div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      dataList: [],
      sxType: '',
      h: '500px',
      showContent: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let methods = 'getProductList'
      let extra = this.info.extra || {}
      let showContent = extra.showContent || []
      let h = 80
      if (showContent.includes('商品名称')) {
        h += 16
      }
      if (showContent.includes('商品图片')) {
        h += 360
      }
      if (showContent.includes('商品价格')) {
        h += 58
      }
      if (showContent.includes('商品品牌') || showContent.includes('商品分类')) {
        h += 26
      }
      this.sxType = extra.sxType
      if (!extra.goodsUuids.length) {
        return
      }
      let params = { uuidList: extra.goodsUuids, status: 1 }
      if (this.sxType === 1) {
        methods = 'getSoftWareSystemsList'
        params = { softwareSystemUuids: extra.goodsUuids }
        h = 500
        showContent = ['商品名称', '商品图片']
      };
      this.showContent = showContent
      this.h = `${h}px`
      this.API.product[methods]({
        currentPage: 1,
        pageSize: 500,
        ...params
      }).then((res) => {
        let data = res.data || []
        data.map(o => {
          o.name = o.productName || o.softwareSystemName
          o.img = o.systemPhoto ? o.systemPhoto.split(',')[0] : o.frontCover
          return o
        })
        if (data.length) {
          this.dataList = _.chunk(data, 3)
        }
      })
    },
    goDetail (o) {
      this.$router.push({
        name: this.sxType === 1 ? 'systemDetail' : 'productDetail',
        query: {
          id: o.uuid || o.softwareSystemUuid
        }
      })
    }
  }
}
</script>
